"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityFinalNegotiationQuoteCoverDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_final_negotiation_entity_1 = require("./opportunity-final-negotiation.entity");
let OpportunityFinalNegotiationQuoteCoverDetail = class OpportunityFinalNegotiationQuoteCoverDetail {
};
exports.OpportunityFinalNegotiationQuoteCoverDetail = OpportunityFinalNegotiationQuoteCoverDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteCoverDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_final_negotiation_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteCoverDetail.prototype, "opportunityFinalNegotiationId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "quote_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteCoverDetail.prototype, "quoteId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteCoverDetail.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_map_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityFinalNegotiationQuoteCoverDetail.prototype, "coverMapId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_cover_response", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityFinalNegotiationQuoteCoverDetail.prototype, "insurerCoverResponse", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityFinalNegotiationQuoteCoverDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityFinalNegotiationQuoteCoverDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_final_negotiation_entity_1.OpportunityFinalNegotiation, (neg) => neg.quoteCovers, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_final_negotiation_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object)
], OpportunityFinalNegotiationQuoteCoverDetail.prototype, "finalNegotiation", void 0);
exports.OpportunityFinalNegotiationQuoteCoverDetail = OpportunityFinalNegotiationQuoteCoverDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_final_negotiation_quote_cover_detail")
], OpportunityFinalNegotiationQuoteCoverDetail);
